(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.scrollFrame = 0;
      this.isScrolling = 0;
      this.isPastHeader = false;
    }

    connectedCallback() {
      if (Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-" + this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-" + this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-" + this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-" + this.dataset.customTransparentHeaderColorScheme;

      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.mobileMedia = window.matchMedia('(max-width: 989px)');
      this.headerBounds = { top: 0, bottom: this.header.offsetHeight };
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.hasTransparentHome = Boolean(
        Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')
      );

      this.setHeaderHeightHandler = () => this.setHeaderHeight();
      this.breakpointHandler = () => {
        this.updateStickyMode();
        this.setHeaderHeight();
      };
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.updateStickyMode();
      this.setHeaderHeight();

      /* Sem animação/estado por scroll: mantém o header estável e opaco. */
      if (this.hasTransparentHome) this.setOpaqueStyle();

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('resize', this.setHeaderHeightHandler, { passive: true });
      this.desktopMedia.addEventListener?.('change', this.breakpointHandler);
    }

    updateStickyMode() {
      const stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size' || this.desktopMedia.matches;
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    }

    setHeaderHeight() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      if (height > 0) document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('resize', this.setHeaderHeightHandler);
      this.desktopMedia?.removeEventListener?.('change', this.breakpointHandler);
      if (this.isScrolling) clearTimeout(this.isScrolling);
    }

    setOpaqueStyle() {
      if (!this.hasTransparentHome) return;
      this.classList.add(this.defaultColorScheme, this.defaultCustomColorScheme);
      this.classList.remove('dbtfy-header--transparent');
      if (this.transparentColorScheme) this.classList.remove(this.transparentColorScheme);
      if (this.transparentCustomColorScheme) this.classList.remove(this.transparentCustomColorScheme);
    }

    setTransparentStyle() {
      if (!this.hasTransparentHome) return;
      this.classList.add(this.transparentColorScheme, this.transparentCustomColorScheme, 'dbtfy-header--transparent');
      if (this.defaultColorScheme) this.classList.remove(this.defaultColorScheme);
      if (this.defaultCustomColorScheme) this.classList.remove(this.defaultCustomColorScheme);
    }

    hide() {
      /* Header intentionally remains visible: no scroll animation. */
      this.header?.classList.remove('shopify-section-header-hidden', 'animate');
    }

    reveal() {
      this.header?.classList.remove('shopify-section-header-hidden', 'animate');
    }

    reset() {
      this.header?.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
